'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _icons = require('icons/icons');

var icons = _interopRequireWildcard(_icons);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _ChatHead = require('conversations-core/components/chat/ChatHead');

var _ChatHead2 = _interopRequireDefault(_ChatHead);

var _strings = require('conversations-core/constants/strings');

var _AvatarSize = require('conversations-core/constants/AvatarSize');

var _AvatarSize2 = _interopRequireDefault(_AvatarSize);

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'WidgetHeader',

  propTypes: {
    coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default).isRequired,
    avatar: _react.PropTypes.string,
    name: _react.PropTypes.string.isRequired,
    onClick: _react.PropTypes.func.isRequired,
    onClose: _react.PropTypes.func.isRequired,
    jobTitle: _react.PropTypes.string,
    aboutMe: _react.PropTypes.string,
    displayResponderOnline: _react.PropTypes.bool.isRequired,
    mobile: _react.PropTypes.bool
  },

  getHeaderClassName: function getHeaderClassName() {
    var _props = this.props,
        mobile = _props.mobile,
        jobTitle = _props.jobTitle,
        aboutMe = _props.aboutMe;


    return (0, _reactUtils.classNames)('widget-header p-x-10', {
      mobile: mobile,
      'has-extra-about': jobTitle || aboutMe
    });
  },
  renderJobTitle: function renderJobTitle() {
    var jobTitle = this.props.jobTitle;


    if (!jobTitle) {
      return null;
    }

    return _react2.default.createElement(
      'p',
      { className: 'm-bottom-1' },
      _react2.default.createElement(
        'b',
        null,
        jobTitle
      )
    );
  },
  renderAboutMe: function renderAboutMe() {
    var aboutMe = this.props.aboutMe;


    if (!aboutMe) {
      return null;
    }

    return _react2.default.createElement(
      'p',
      { className: 'm-bottom-0 p-bottom-2' },
      _react2.default.createElement(
        _Small2.default,
        { style: { display: 'inline-block' } },
        aboutMe
      )
    );
  },
  renderCloseButton: function renderCloseButton() {
    var _props2 = this.props,
        mobile = _props2.mobile,
        onClose = _props2.onClose;


    if (!mobile) {
      return null;
    }

    return _react2.default.createElement(
      _UIButton2.default,
      {
        className: 'widget-close-button',
        use: 'unstyled',
        size: 'small',
        onClick: onClose
      },
      _react2.default.createElement(_UIIcon2.default, { name: icons.REMOVE })
    );
  },
  render: function render() {
    var _props3 = this.props,
        avatar = _props3.avatar,
        name = _props3.name,
        displayResponderOnline = _props3.displayResponderOnline,
        onClick = _props3.onClick,
        mobile = _props3.mobile,
        textColor = _props3.coloring.textColor;

    var size = mobile ? _AvatarSize2.default.SMALL : _AvatarSize2.default.MEDIUM;

    return _react2.default.createElement(
      'div',
      { className: this.getHeaderClassName(), style: { color: textColor } },
      _react2.default.createElement(
        'div',
        { className: 'widget-header-avatar-wrapper' },
        _react2.default.createElement(_ChatHead2.default, {
          className: 'm-x-auto',
          size: size,
          avatar: avatar,
          online: displayResponderOnline,
          showStatus: true,
          onClick: onClick
        }),
        _react2.default.createElement(
          'h5',
          { className: 'text-center m-y-1' },
          _react2.default.createElement(
            'span',
            { className: 'widget-header-name p-y-1 p-x-2', onClick: onClick },
            name
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: _strings.USER_DESCRIPTION_NODE_CLASSNAME },
        this.renderJobTitle(),
        this.renderAboutMe()
      ),
      _react2.default.createElement(
        'div',
        { className: 'widget-close-button-wrapper' },
        this.renderCloseButton()
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/widget/WidgetHeader.js
// module id = 282
// module chunks = 0 1